import React from 'react';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import styles from './AboutHeadDark.module.scss';
import classNames from 'classnames';
import { Button } from '~/vinovest-design-system/components';
import { baseRoutes } from '~/routes/base';
import Image from 'next/image';
import Hero from '../../../../../assets/img/about/hero.png';

export const AboutHeadDark = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <div className={styles.container} ref={ref}>
            <div className={'text'}>
                <h1 className={runAnimation}>Investing in Tradition</h1>
                <p className={classNames('description', runAnimation)}>
                    Fine wine and whiskey have long been cornerstones of wealth generation and preservation. With
                    data-driven strategies and a personalized platform, Vinovest makes building your portfolio simple.
                </p>
                <Button
                    variant={'green'}
                    href={baseRoutes.signup.href}
                    font={'font-vinovest-medium'}
                    classnames={'text-16 !capitalize'}
                >
                    Get Started
                </Button>
            </div>
            <div className={'image'}>
                <div className={'imageBox'}>
                    <Image src={Hero} alt={'Scale of wealth inwine investing'} />
                    <div className={'textBox'}>
                        <div className={'box'}>
                            DLynn Proctor
                            <span>Master Sommelier / Advisor</span>
                        </div>
                        <div className={'box'}>
                            Dustin WIlson
                            <span>Master Sommelier / Advisor</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
